import React, { useState, useEffect } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import { AiOutlineHome, AiOutlineMail } from "react-icons/ai";
import { BiPhoneCall, BiInfoCircle } from "react-icons/bi";
import Container from "../components/Container";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createQuery } from "../features/contact/contactSlice";

let contactSchema = yup.object({
  name: yup.string().required("First Name is Required"),
  email: yup
    .string()
    .required("Email is Required")
    .email("Email Should be valid"),
  mobile: yup.number().required().positive().integer("Mobile No is Required"),
  comment: yup.string().required("comments is Required"),
});

const Contact = () => {
  const dispatch = useDispatch();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const contactState = useSelector((state) => state.contact);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      mobile: "",
      comment: "",
    },
    validationSchema: contactSchema,
    onSubmit: (values) => {
      dispatch(createQuery(values));
      setShowSuccessPopup(true);
    },
  });

  useEffect(() => {
    if (contactState.isSuccess && contactState.createdQuery) {
      // Auto-close modal after 2 seconds and reset form
      setTimeout(() => {
        setShowSuccessPopup(false);
        formik.resetForm();
      }, 2000);
    } else if (contactState.isError) {
      // Auto-close modal after 2 seconds on error
      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 2000);
    }
  }, [contactState.isSuccess, contactState.createdQuery, contactState.isError, formik]);

  const closePopup = () => {
    setShowSuccessPopup(false);
  };
  return (
    <>
      <Meta title={"Contact Us"} />
      <BreadCrumb title="Contact Us" />
      <Container class1="contact-wrapper py-5 home-wrapper-2">
        <div className="row">
          {/* <div className="col-12">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d112339.47764741142!2d77.18691214459811!3d28.370678278134093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x390cdebc08d9a897%3A0x9a08ce466bd350ce!2sNangla%20Enclave%20Part%202%2C%20Ghazipur%2C%20Sector%2051%2C%20Faridabad%2C%20Haryana%20121005%2C%20India!3m2!1d28.370552!2d77.26931479999999!5e0!3m2!1sen!2sin!4v1743834923163!5m2!1sen!2sin"
              width="600"
              height="450"
              className="border-0 w-100"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div> */}
          <div className="col-12 mt-5">
            <div className="contact-inner-wrapper d-flex justify-content-between ">
              <div>
                <h3 className="contact-title mb-4">Contact</h3>
                <form
                  action=""
                  onSubmit={formik.handleSubmit}
                  className="d-flex flex-column gap-15"
                >
                  <div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      name="name"
                      onChange={formik.handleChange("name")}
                      onBlur={formik.handleBlur("name")}
                      value={formik.values.name}
                    />
                    <div className="error">
                      {formik.touched.name && formik.errors.name}
                    </div>
                  </div>

                  <div>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      onChange={formik.handleChange("email")}
                      onBlur={formik.handleBlur("email")}
                      value={formik.values.email}
                    />
                    <div className="error">
                      {formik.touched.email && formik.errors.email}
                    </div>
                  </div>
                  <div>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Mobile Number"
                      name="mobile"
                      onChange={formik.handleChange("mobile")}
                      onBlur={formik.handleBlur("mobile")}
                      value={formik.values.mobile}
                    />
                    <div className="error">
                      {formik.touched.mobile && formik.errors.mobile}
                    </div>
                  </div>
                  <div>
                    <textarea
                      id=""
                      className="w-100 form-control"
                      cols="30"
                      rows="4"
                      placeholder="Comments"
                      name="comment"
                      onChange={formik.handleChange("comment")}
                      onBlur={formik.handleBlur("comment")}
                      value={formik.values.comment}
                    ></textarea>
                    <div className="error">
                      {formik.touched.comment && formik.errors.comment}
                    </div>
                  </div>
                  <div>
                    <button 
                      className="button border-0" 
                      type="submit" 
                      disabled={contactState.isLoading}
                    >
                      {contactState.isLoading ? "Sending..." : "Submit"}
                    </button>
                  </div>
                  {contactState.isError && (
                    <div className="error mt-3">
                      Something went wrong. Please try again later.
                    </div>
                  )}
                </form>
              </div>
              <div>
                <h3 className="contact-title mb-4">Get in touch with us</h3>
                <div>
                  <ul className="ps-0">
                    {/* <li className="mb-3 d-flex gap-15 align-items-center">
                      <AiOutlineHome className="fs-5" />
                      <address className="mb-0">
                        Hno : 12B Nangla Enclave Part 2, Sector 51, Ghazipur,
                        Faridabad, Haryana 121005, India
                      </address>
                    </li> */}
                    {/* <li className="mb-3 d-flex gap-15 align-items-center">
                      <BiPhoneCall className="fs-5" />
                      <a href="tel:+91 8287049939">+91 8287049939</a>
                    </li> */}
                    <li className="mb-3 d-flex gap-15 align-items-center">
                      <AiOutlineMail className="fs-5" />
                      <a href="mailto:support@shoplintic.in">
                        support@shoplintic.in
                      </a>
                    </li>
                    {/* <li className="mb-3 d-flex gap-15 align-items-center">
                      <BiInfoCircle className="fs-5" />
                      <p className="mb-0">Monday – Friday 10 AM – 8 PM</p>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* Success Modal */}
      {showSuccessPopup && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" 
             style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: 1050 }}>
          <div className="bg-white rounded-3 shadow-lg p-4 mx-3" style={{ maxWidth: '400px', width: '100%' }}>
            <div className="text-center">
              {contactState.isLoading ? (
                <>
                  <div className="mb-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <h4 className="text-primary mb-3">Sending Message...</h4>
                  <p className="text-muted mb-4">
                    Please wait while we send your message.
                  </p>
                </>
              ) : contactState.isSuccess && contactState.createdQuery ? (
                <>
                  <div className="mb-3">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-success mx-auto">
                      <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7089 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M22 4L12 14.01L9 11.01" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h4 className="text-success mb-3">Message Sent Successfully!</h4>
                  <p className="text-muted mb-4">
                    Thank you for contacting us! Your message has been sent successfully. Our team will get back to you within 24 hours.
                  </p>
                  <button 
                    className="btn btn-success px-4 py-2" 
                    onClick={closePopup}
                    style={{ minWidth: '100px' }}
                  >
                    OK
                  </button>
                </>
              ) : contactState.isError ? (
                <>
                  <div className="mb-3">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-danger mx-auto">
                      <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h4 className="text-danger mb-3">Failed to Send Message</h4>
                  <p className="text-muted mb-4">
                    Sorry, there was an error sending your message. Please try again later.
                  </p>
                  <button 
                    className="btn btn-danger px-4 py-2" 
                    onClick={closePopup}
                    style={{ minWidth: '100px' }}
                  >
                    Close
                  </button>
                </>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Contact;
